var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPepperoni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 10,
    ry: 290,
    rx: 290,
    id: "svg_1",
    cy: 300,
    cx: 300,
    stroke: "#630909",
    fill: "#ad3939"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 40,
    rx: 43,
    id: "svg_2",
    cy: 162.5,
    cx: 227,
    strokeWidth: 0,
    stroke: "#630909",
    fill: "#d67373"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 40,
    rx: 43,
    id: "svg_3",
    cy: 230.5,
    cx: 395,
    strokeWidth: 0,
    stroke: "#630909",
    fill: "#d67373"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 40,
    rx: 43,
    id: "svg_4",
    cy: 334.5,
    cx: 98,
    strokeWidth: 0,
    stroke: "#630909",
    fill: "#d67373"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 40,
    rx: 43,
    id: "svg_5",
    cy: 376.5,
    cx: 453,
    strokeWidth: 0,
    stroke: "#630909",
    fill: "#d67373"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 40,
    rx: 43,
    id: "svg_6",
    cy: 458.5,
    cx: 245,
    strokeWidth: 0,
    stroke: "#630909",
    fill: "#d67373"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepperoni);
export default __webpack_public_path__ + "static/media/Pepperoni.d20dce47f1a4ebdd694671e862bd0741.svg";
export { ForwardRef as ReactComponent };